const routes = [
    {
        path: '/',
        component: () => import('../components/task/TaskList.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/projects',
        children: [
            {
                path: '',
                name: 'projects',
                meta: {
                    title: 'Проекты',
                    searchAction: false,
                    headerMenuAction: false
                },
                component: () => import('../components/project/ProjectList.vue')
            },
            {
                path: 'add',
                meta: {
                    title: 'Новый проект',
                    headerType: 'back'
                },
                name: 'projectAdd',
                component: () => import('../components/project/ProjectEdit.vue')
            },
            {
                path: ':id',
                children: [
                    {
                        path: '',
                        name: 'project',
                        meta: {
                            title: 'Проект',
                            headerType: 'back'
                        },
                        component: () => import('../components/project/ProjectDetail.vue')
                    },
                    {
                        path: 'edit',
                        name: 'projectEdit',
                        meta: {
                            title: 'Редактирование проекта',
                            headerType: 'back'
                        },
                        component: () => import('../components/project/ProjectEdit.vue')
                    }
                ]
            }
        ],
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/tasks',
        children: [
            {
                path: '',
                name: 'tasks',
                meta: {
                    title: 'Задачи',
                    searchAction: true,
                    headerMenuAction: true,
                    headerProjectAction: true
                },
                component: () => import('../components/task/TaskList.vue')
            },
            {
                path: 'add',
                name: 'taskAdd',
                meta: {
                    title: 'Новая задача',
                    headerType: 'back'
                },
                component: () => import('../components/task/TaskEdit.vue')
            },
            {
                path: ':id',
                children: [
                    {
                        path: '',
                        name: 'task',
                        meta: {
                            title: 'Задача',
                            headerType: 'back'
                        },
                        component: () => import('../components/task/TaskDetail.vue')
                    },
                    {
                        path: 'comments',
                        name: 'taskComments',
                        meta: {
                            title: 'Комментарии к задаче:',
                            headerType: 'back',
                            footerType: 'comment',
                            bgImg: 'img/chat-bg-pattern-light.png'
                        },
                        component: () => import('../components/task/TaskComments.vue')
                    },
                    {
                        path: 'edit',
                        name: 'taskEdit',
                        meta: {
                            title: 'Редактирование задачи',
                            headerType: 'back'
                        },
                        component: () => import('../components/task/TaskEdit.vue')
                    }
                ]
            }
        ],
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/settings',
        children: [
            {
                path: 'notifications',
                name: 'NotificationSettings',
                meta: {
                    title: 'Настройка уведомлений',
                },
                component: () => import('../components/settings/NotificationSettings.vue')
            },
            {
                path: 'profile',
                name: 'ProfileSettings',
                meta: {
                    title: 'Мой профиль',
                },
                component: () => import('../components/settings/ProfileSettings.vue')
            }
        ],
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/auth',
        component: () => import('../components/AppAuth.vue')
    }
]

export default routes